// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 596 ? "178e4091" : chunkId) + "." + {"596":"ad684feb66a77bfb","7276":"e838e888482de113"}[chunkId] + ".js";
};